import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

interface Props {
  currentYear: number;
  title?: string;
  data: {
    availableNights: { current: number | string; previous: number | string };
    occupiedNights: { current: number | string; previous: number | string };
    persons: { current: number | string; previous: number | string };
    averageOccupancy: { current: number | string; previous: number | string };
  };
}

const WeeklyComparisonTable = ({ currentYear, title, data }: Props) => {
  const calculatePercentageChange = (previous: number | string, current: number | string) => {
    if (previous === "N/A" || current === "N/A") return "N/A";
    const prevNum = typeof previous === "number" ? previous : parseFloat(previous);
    const currNum = typeof current === "number" ? current : parseFloat(current);
    if (prevNum === 0) return "—";
    const change = ((currNum - prevNum) / prevNum) * 100;
    return `${change.toFixed(1)}%`;
  };

  return (
    <Paper
      elevation={4}
      sx={{ mt: 3, boxShadow: 3, borderRadius: 2, overflow: "hidden" }}
    >
      <Typography
        variant="h6"
        align="center"
        sx={{ pt: 2, pb: 2, backgroundColor: "#fbeaec" }}
      >
        {title || "Comparaison hebdomadaire"}
      </Typography>
      <Table sx={{ maxWidth: "100%", boxShadow: 3, borderRadius: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              sx={{ fontSize: "1rem", backgroundColor: "#f5f5f5" }}
            >
              Indicateur
            </TableCell>
            <TableCell
              align="center"
              sx={{
                fontSize: "1rem",
                backgroundColor: "#f5f5f5",
                color: "#bf2f38",
              }}
            >
              {currentYear - 1}
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontSize: "1rem", backgroundColor: "#f5f5f5" }}
            >
              {currentYear}
            </TableCell>
            <TableCell
              align="center"
              sx={{
                fontSize: "1rem",
                backgroundColor: "#f5f5f5",
                color: "#444",
              }}
            >
              Écarts (%)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[
            {
              label: "Nuitées disponibles",
              values: data.availableNights,
            },
            {
              label: "Nuitées occupées",
              values: data.occupiedNights,
            },
            {
              label: "Personnes",
              values: data.persons,
            },
            {
              label: "Taux d'occupation",
              values: data.averageOccupancy,
              isPercent: true,
            },
          ].map((row, idx) => (
            <TableRow
              key={idx}
              sx={{ backgroundColor: idx % 2 === 0 ? "#fafafa" : "#fff" }}
            >
              <TableCell
                align="center"
                sx={{ fontSize: "0.9rem", color: "#222222" }}
              >
                {row.label}
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontSize: "0.9rem", color: "#bf2f38" }}
              >
                {row.values.previous}
                {row.isPercent && row.values.previous !== "N/A" ? "%" : ""}
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontSize: "0.9rem", color: "#222222" }}
              >
                {row.values.current}
                {row.isPercent && row.values.current !== "N/A" ? "%" : ""}
              </TableCell>
              <TableCell
                align="center"
                sx={{ fontSize: "0.9rem", color: "#444" }}
              >
                {calculatePercentageChange(
                  row.values.previous,
                  row.values.current
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default WeeklyComparisonTable;
